import  { useState} from 'react';
import './App.css';



import {AuthProvider,  UserManager} from 'oidc-react';

import AppContent from './AppContent';



function App() {


    const [userManager] = useState(new UserManager({ 
        redirect_uri: process.env.REACT_APP_REDIRECT_URI as string, 
        client_id: 'postool',
        authority: process.env.REACT_APP_AUTHORITY as string,
        automaticSilentRenew: true,
        silent_redirect_uri: process.env.REACT_APP_REDIRECT_URI as string,
        post_logout_redirect_uri: process.env.REACT_APP_REDIRECT_URI as string
    }));
  

    return (
        <AuthProvider userManager={userManager} autoSignIn={true}>
            <AppContent /> 
        </AuthProvider>
    );
}

export default App;
